import Modal from "components/common/Modal";
import React, { FC } from "react";
import { toast } from "react-toastify";
import { getOnEmailThunk } from "store/thunk/hcr.thunk";
import { useAppDispatch, useAppSelector } from "utils/hooks";

interface SentEmailModalProps {
  showModal: boolean;
  onClose: any;
  hcrDetails: any;
}

const SentEmailModal: FC<SentEmailModalProps> = ({ showModal, onClose, hcrDetails }) => {
  const dispatch = useAppDispatch();

  const isLoading = useAppSelector((state) => state.rootReducer.hcrSlice.mailLoading);

  const sendEmailHandler = () => {
    dispatch(getOnEmailThunk({ _id: hcrDetails?._id }))
      .unwrap()
      .then((data) => {
        if (data?.success) {
          toast.success(data?.message);
          onClose();
        }
      });
  };

  const mails = `${hcrDetails.policyId && hcrDetails.policyId.owner && hcrDetails.policyId.owner.email ? hcrDetails.policyId.owner.email + "," : ""}${hcrDetails.policyId && hcrDetails.policyId.creator && hcrDetails.policyId.creator.email ? hcrDetails.policyId.creator.email + "," : ""}${hcrDetails.policyHolderEmail ? hcrDetails.policyHolderEmail : ""}`;
  return (
    <Modal isOpen={showModal} onClose={onClose} className="w-[30rem] bg-white" style={{ boxShadow: "0px 8px 32px 0px #493E8320" }}>
      <p className="p-5 font-medium" style={{ boxShadow: "0px 8px 32px 0px #493E8320" }}>
        Do you want to send claim form on <span className="font-bold">{mails} ?</span>
      </p>
      <div className="py-5 flex justify-center gap-4">
        <button onClick={sendEmailHandler} className={`bg-polyfix-gradient h-12 rounded-lg min-w-44 md:min-w-52 font-bold flex items-center justify-center gap-3 ${isLoading && "opacity-50 pointer-events-none"}`}>
          {isLoading ? <div className="w-4 h-4 border-[2px] border-t-[#dea15c]  rounded-full animate-spin"></div> : "Yes"}
        </button>
      </div>
    </Modal>
  );
};

export default SentEmailModal;
